import Api from "./Api";
import Csrf from "./Csrf";

export default {

  async getMenus(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/menus");
  },

  createMenuNew(locationid) {
    return Api.get("/locations/" + locationid + "/menus/create-new");
  },

  async getMenu(id, idmenu) {
    await Csrf.getCookie();

    return Api.get("/locations/" + id + "/menus/" + idmenu);
  },

  async updatePositions(id, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/menus/positions", form);
  },

  async updateStatus(id, idmenu, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/menus/" + idmenu + "/status", form);
  },

  async compose(id, idmenu) {
    await Csrf.getCookie();

    return Api.get("/locations/" + id + "/menus/" + idmenu + "/compose");
  },

  async updateCompose(id, idmenu, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/menus/" + idmenu + "/compose", form);
  },

  async createMenu(locationid, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + locationid + "/menus/create", form);
  },

  async updateMenu(id, idmenu, form) {
    await Csrf.getCookie();
    form._method = "PATCH";

    return Api.post("/locations/" + id + "/menus/" + idmenu, form);
  },

  async dishes(id, idmenu) {
    await Csrf.getCookie();

    return Api.get("/locations/" + id + "/menus/" + idmenu + "/dishes");
  },

  async allergiesAttributes() {
    await Csrf.getCookie();

    return Api.get("/allergies-attributes");
  },

  async deleteMenu(locationid, idmenu) {
    await Csrf.getCookie();

    return Api.post("/locations/" + locationid + "/menus/"+ idmenu, { _method: "DELETE" });
  },


  
  async dishesList(id) {
    await Csrf.getCookie();

    return Api.get("/locations/" + id + "/menus/dishes");
  },

  async themes(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/themes");

  },

  async saveTheme(locationid, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + locationid + "/themes", form);

  },

  /*
  async getCategories(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/categories");
  },

  createCategoryNew(locationid) {
    return Api.get("/locations/" + locationid + "/categories/create-new");
  },

  async createCategory(locationid, form) {
    await Csrf.getCookie();

    return Api.post("/locations/" + locationid + "/categories/create", form);
  },

  async getCategory(id, idcategory) {
    await Csrf.getCookie();

    return Api.get("/locations/" + id + "/categories/" + idcategory);
  },

  async updateCategory(id, idcategory, form) {
    await Csrf.getCookie();
    form._method = "PATCH";

    return Api.post("/locations/" + id + "/categories/" + idcategory, form);
  },

  async getLanguages(locationid) {
    await Csrf.getCookie();

    return Api.get("/locations/" + locationid + "/languages");
  },

  async deleteCategory(id, idcategory) {
    await Csrf.getCookie();

    return Api.post("/locations/" + id + "/categories/" + idcategory, { _method: "DELETE" });
  }
  */
};